import io from 'socket.io-client'
import { feathers, type Application } from '@feathersjs/feathers'
import socketioClient from '@feathersjs/socketio-client'
import authentication from '@feathersjs/authentication-client'
import { getSocketOrigin } from '../config/keys'

let client: Application | null = null
let socket: ReturnType<typeof io> | null = null
let authenticatedToken: string | null = null

export function disconnectFeathersSocket(): void {
  try {
    socket?.disconnect()
  } finally {
    socket = null
    client = null
    authenticatedToken = null
  }
}

export async function getAuthenticatedFeathersClient(accessToken: string): Promise<Application> {
  if (client && socket?.connected && authenticatedToken === accessToken) {
    return client
  }

  disconnectFeathersSocket()

  const url = getSocketOrigin()
  socket = io(url, {
    transports: ['polling', 'websocket'],
    upgrade: true,
    forceNew: true,
    timeout: 25_000,
    reconnection: true,
    reconnectionAttempts: 12,
  })

  const app = feathers()
  app.configure(socketioClient(socket))
  app.configure(authentication())

  await app.authenticate({ strategy: 'jwt', accessToken })

  client = app
  authenticatedToken = accessToken
  return app
}
